import { api } from "@/shared/api";
import { queryKeys } from "@/shared/query";
import { Alert, LoadingBlock } from "@/shared/ui/primitives";
import { useQuery } from "@tanstack/react-query";
import { Navigate } from "@tanstack/react-router";
import { Compass } from "lucide-react";

export function RootEntry() {
  const session = useQuery({
    queryKey: queryKeys.session,
    queryFn: api.auth.session,
    retry: false,
  });

  if (session.isPending) {
    return (
      <main className="entry-screen" id="main-content">
        <div className="brand-lockup brand-lockup--centered">
          <span className="brand-mark">
            <Compass aria-hidden="true" />
          </span>
          <strong>Polaris Leads</strong>
        </div>
        <LoadingBlock lines={3} label="Apertura dello spazio di lavoro" />
      </main>
    );
  }
  if (session.isError) return <Navigate to="/login" replace />;
  const workspace = session.data.workspaces[0];
  if (!workspace) {
    return (
      <main className="entry-screen" id="main-content">
        <Alert tone="warning" title="Nessuno spazio di lavoro disponibile">
          Chiedi a un amministratore di invitarti, poi riapri questa pagina.
        </Alert>
      </main>
    );
  }
  return (
    <Navigate to="/w/$workspaceSlug/inbox" params={{ workspaceSlug: workspace.slug }} replace />
  );
}
